import ExerciseItem from './custom-elements/ExerciseItem.js'
import ExerciseDialog from './custom-elements/ExerciseDialog.js'
import ExercisesView from './custom-elements/ExercisesView.js'
import Values from './custom-elements/Values.js'
import WorkoutView from './custom-elements/WorkoutView.js'
import PerformExercise from './custom-elements/PerformExercise.js'
import Stepper from './custom-elements/Stepper.js'
import App from './custom-elements/App.js'

customElements.define('gime-exercise-item', ExerciseItem)
customElements.define('gime-exercise-dialog', ExerciseDialog)
customElements.define('gime-exercises-view', ExercisesView)
customElements.define('gime-values', Values)
customElements.define('gime-workout-view', WorkoutView)
customElements.define('gime-perform-exercise', PerformExercise)
customElements.define('gime-stepper', Stepper)
customElements.define('gime-app', App)
